import { ConfiguracionFicha } from 'src/app/compartido/ficha/utilidades/ficha.models';

/* Configuración de la ficha de calendario general */
export const CONFIGURACION_FICHA_CALENDARIO_GENERAL: ConfiguracionFicha = {
  contenido: { padding: true },
};
